import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MsgConfig } from 'src/app/app.messages';
import { SystemData } from 'src/app/models';
import { AlertService, CommonService, ErxService, PatPreDrugModalService } from 'src/app/services';
import { StorageService } from 'src/app/services/storage.service';
import { PatientInfoUtil } from 'src/app/utils/patient-info.util';
import { CommonWarnorconfirmPopupComponent } from '../common-warnorconfirm-popup/common-warnorconfirm-popup.component';
import * as _ from "lodash";
import { PatientLabels } from 'src/app/models/labels.models';
import { OverrideLogComponent } from '../override-log/override-log.component';
import { CommonUtil } from 'src/app/utils';
import { environment } from "src/environments/environment";
import * as moment from 'moment';

@Component({
  selector: 'app-patient-selection',
  templateUrl: './patient-selection.component.html',
  styleUrls: ['./patient-selection.component.scss'],
  standalone: false
})
export class PatientSelectionComponent implements OnInit {
  selectedPatientDetails: any;
  patientSearchValue: any = "";
  IsFocusField: string = "";
  systemData: SystemData;
  SearchPatient: boolean = false;
  unsubscribe$: Subject<void> = new Subject();
  primaryInsu: any;
  msgConfig = MsgConfig;
  isfromPatientHistory: boolean = false;
  @Input() IsfrmPatHis;
  @Input() IsTransferType;
  @Input() IsPush;
  @Input() IsTitle;
  @Input() PatientNotFound:number;
  @Input() IsFromProcess:boolean;
  @Input() CurrentDetails:any;
  @Input() SelectedRecords:any;
  
  isFocus: boolean = true;
  requestedInfor: any;
  detailsInfo:any;
  isIvrEnabled = environment.isIvrEnabled;
  isMultiPatient: boolean = false;
  isPatientReselected: boolean = false;
  isPatientOverride: boolean = false;
  isPatientNewlyAdded: boolean = false;
  @Input()
  set RequestedInfo(requestedInfo : any) {
      if(requestedInfo) {
        this.requestedInfor = requestedInfo;
        this.checkIsActivePatient(requestedInfo, true);
      } else {
        this.requestedInfor = null;
      }
  }

  @Input()
  set SelectedPatientDetailsfrmRx(patient : any){
      if(patient) {
        this.isfromPatientHistory = patient?.IsFromNotHistory ? false : true;
        this.checkIsActivePatient(patient);
      } else {
         this.selectedPatientDetails = null;
          this.primaryInsu = null;
      }
  }
  
  @Input()
  set PatientDetails(patient : any){
      if(patient) {
        this.isfromPatientHistory = true;
        this.checkIsActivePatient(patient);
      }
  }
  isPatientReselect: boolean = false;
  @Output() SelectedPatientID = new EventEmitter();
   public _erxService = inject(ErxService);
patientLabels = new PatientLabels();
  constructor(private _modalService:NgbModal,
              private _cdr: ChangeDetectorRef,
              private _commonServ:CommonService,
              private _ppdiModalSer: PatPreDrugModalService, private _alerSer: AlertService,
              private _patientUtil: PatientInfoUtil, private _comnUtil:CommonUtil,
              private _storageService: StorageService) { 
             
                this._commonServ.systemData$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(resp => {
                    if (resp) {
                        this.systemData = resp;
                    }
                });
              }

  ngOnInit(): void {
    this.selectedPatientDetails = this.requestedInfor ? this.requestedInfor : this.selectedPatientDetails;
    if(this.selectedPatientDetails) {
      this.primaryInsu = _.filter(this.selectedPatientDetails?.insurance, {
          insuranceid: +this.selectedPatientDetails.insuranceid
        })[0];
          if (!this.primaryInsu) {
            this.primaryInsu = _.filter(this.selectedPatientDetails.insurance, {
                IsCash: true
            })[0];
        }
        if (!this.primaryInsu) {
            this.primaryInsu = _.filter(this.selectedPatientDetails.insurance, {
                insurerid: this.systemData["DefaultValuese"][0]["CashInsurerId"]
            })[0];
        }
        if (!this.primaryInsu) {
            this.primaryInsu = _.filter(this.selectedPatientDetails.insurance, {
                insuranceid: 10189
            })[0];
          } 
    }
    this.isIvrEnabled = environment.isIvrEnabled && this._storageService.get("IvrGUIDDetails") ? true : false;
    this.isMultiPatient = (this.IsFromProcess || this.IsPush) && this.CurrentDetails && this.CurrentDetails?.PatientFound > 1;
    if(this.IsPush) {
      this.PatientNotFound = this.CurrentDetails?.PatientFound;
    }
  }
  showPatientNotFound() {
    this.isFocus = false;
    const modelRef = this._modalService.open(CommonWarnorconfirmPopupComponent, {
                backdrop: false,
                keyboard: false, windowClass: "large--content"
            });
            modelRef.componentInstance.warnMsg = "The requested patient could not be found. Please select a different patient to proceed.";
            modelRef.componentInstance.okButton = true;
            modelRef.componentInstance.IsPopUpClosed.pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
                modelRef.close();
                this.overrideOnPatientPrescriberChange("Patient","PatientChange");
            });
  }
 overrideOnPatientPrescriberChange(CategoryType, type, patient?, IsfromMultiMatch?) {
         let modelRefChange = this._modalService.open(OverrideLogComponent, {
             centered: true,
             keyboard: false, backdrop: false, windowClass:'medium-modal-50'
         });
         modelRefChange.componentInstance.PrivMask = type;
         modelRefChange.componentInstance.CatId = CategoryType;
         modelRefChange.componentInstance.IsfromMultiMatch = this.isMultiPatient  ? IsfromMultiMatch : false;
         modelRefChange.componentInstance.WarMessage = "Authorization is required for <b>Patient Change</b> during the " + (!(this.SelectedRecords?.length) ? "Transfer In request process" : "Transfer Out") + ". Please provide authorization below:";
         modelRefChange.componentInstance.category = "Patient";
         modelRefChange.componentInstance.IsNotesDisplay = true;
        modelRefChange.componentInstance.IsFrmInfo = true;
         modelRefChange.result.then(res => {
          this.isFocus = false;
          this._cdr.detectChanges();
           if (res) {
            this.isPatientOverride = true;
            this.isMultiPatient = false;
             this.checkIsActivePatient(patient);
             this.selectedPatientDetails = null;
             this._cdr.detectChanges();
             this.selectedPatientDetails = patient;
           }
          this.isFocus = true;
          if(modelRefChange) {
            this.checkIsActivePatient(this.requestedInfor, true);
            modelRefChange.close();
            modelRefChange = null;
          }
         });
 }
  checkIsActivePatient(patient, requestedInfo: boolean = false, IsNotExcusted: boolean = false) {
      this.isPatientReselected = IsNotExcusted;
      this.isPatientNewlyAdded = IsNotExcusted && patient?.IsFromAddNew ? true : false;
      let  isSameMultiMatch  = false;
      if(this.CurrentDetails?.PatientFound > 1) {
           const pName  = this.CurrentDetails['totalItem']['PatientName'].split(", ");
          const dob = moment(this.CurrentDetails['totalItem']['PatientDOB']).format(MsgConfig.DATE_FORMAT)
           isSameMultiMatch = patient?.lastname?.toLowerCase() === pName[0]?.toLowerCase() && patient?.firstname?.toLowerCase() === pName[1]?.toLowerCase() &&  patient?.dob == dob;
      }
      if(isSameMultiMatch) {
          this.isPatientOverride = true;
          this.isMultiPatient = false;
      }
      this.isPatientOverride = this.isPatientOverride ? true : (IsNotExcusted ? (patient?.IsFromAddNew ? true : (this.IsPush ? true : false)) : this.isPatientOverride);
     if(patient && !isSameMultiMatch && (!patient?.IsFromAddNew) && (this.IsFromProcess || this.IsPush) && this.CurrentDetails && (!this.CurrentDetails?.PatientFound || this.CurrentDetails?.PatientFound > 1) && IsNotExcusted) {
       this.overrideOnPatientPrescriberChange("Patient","PatientChange", patient , (this.CurrentDetails?.PatientFound > 1) ?  true : false);
       return; // If patient is not found
    } else if (patient) {
       this.selectedPatientDetails = null;
       this._cdr.detectChanges();
       this.selectedPatientDetails = patient;
      const patientName = patient.fullname ? ((patient.fullname).toUpperCase()).replace("_", ", ") : "";
      if (!requestedInfo && patient && patient["fullname"] && (patient["actstatus"] !== 1) && !patient["IsfromPush"] && !this.IsPush) {
        const warnMsg = "Selected Patient <label><span class='fw-bold'>" + patientName  +"</span></label> is not an Active Patient.";
        this.commonWarnorconfirmPopup({warnMsg: warnMsg, IsHeaderText : MsgConfig.Inactive_Patient, IsFocusField : "patient"});
      } else if (patient && patient.isdeceased && patient.fullname) {
        this.selectedPatientDetails = null;
        this.primaryInsu = null;
        this._alerSer.error("Patient " + patientName  + " is Deceased.");
      }
      else {
        if(requestedInfo)
           this.selectedPatientDetails.requestedInfo = true;
        patient.fullname = patient.fullname ? this._patientUtil.getPatientFullName(patient) : "";
        patient.address = patient ? this._patientUtil.getPatientAddress(patient) : "";
        patient.AllergiesList = (patient?.patallergies?.length) ? this._patientUtil.getPatientAllergies(patient) : "";
        this.IsFocusField = "";
        this._cdr.detectChanges();
        this.IsFocusField = "drug";
        this.primaryInsu = _.filter(this.selectedPatientDetails?.insurance, {
          insuranceid: +this.selectedPatientDetails.insuranceid
        })[0];
          if (!this.primaryInsu) {
            this.primaryInsu = _.filter(this.selectedPatientDetails.insurance, {
                IsCash: true
            })[0];
        }
        if (!this.primaryInsu) {
            this.primaryInsu = _.filter(this.selectedPatientDetails.insurance, {
                insurerid: this.systemData["DefaultValuese"][0]["CashInsurerId"]
            })[0];
        }
        if (!this.primaryInsu) {
            this.primaryInsu = _.filter(this.selectedPatientDetails.insurance, {
                insuranceid: 10189
            })[0];
          } 
      }
      this.patientSearchValue = null;
      this._cdr.detectChanges();
      this.patientSearchValue = true;
      this.SelectedPatientID.emit(patient);
      this._cdr.detectChanges();
    this.SearchPatient = false;
    this._cdr.detectChanges();
    this.SearchPatient = true;
  
} else {
    this.selectedPatientDetails = null;
    this.SearchPatient = true;
    this._cdr.detectChanges();
    this.SearchPatient = false;
    this.primaryInsu = null;
    this.IsFocusField = "patient";
    this.SelectedPatientID.emit();
}
  }
  editPatient(patientid) {
  this._ppdiModalSer._patPreDrugModal$.next("patient");
     const modalRef = this._ppdiModalSer.modalInstanceRef;
     modalRef.componentInstance.patientID  = +patientid;
     modalRef.componentInstance.ClosePatientModal
     .pipe(takeUntil(this.unsubscribe$))
     .subscribe(async resp => {
         modalRef.close();
         if(resp.PatientId)
         {
          const patInfo = await this._commonServ.getRxPatientDetailsById(resp["PatientId"]).toPromise();
          this.checkIsActivePatient(patInfo);
         }
         this._ppdiModalSer._patPreDrugModal$.next(null);
     });
}
  commonWarnorconfirmPopup(object) {
    const modelRef = this._modalService.open(CommonWarnorconfirmPopupComponent, {
      backdrop: false,
      keyboard: false, windowClass: "large--content"
    });
    modelRef.componentInstance.warnMsg = object.warnMsg;
    modelRef.componentInstance.okButton = true;
    modelRef.componentInstance.IsHeaderText = object.IsHeaderText;
    modelRef.componentInstance.IsPopUpClosed.pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
      if(resp)
      {
        modelRef.close();
        this.IsFocusField = "";
        this._cdr.detectChanges();
        this.IsFocusField = object.IsFocusField;
        this.selectedPatientDetails = null;
        this.primaryInsu = null;
      }
    });
  }

  async clickToCallOutBond(mobile) {
    let resp;
    let callRequest = this._comnUtil.clickToOutBondcall(mobile);
    if(callRequest && mobile && this.isIvrEnabled) {
      if(callRequest?.ivrVendor === 1) {
        resp = await this._commonServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
        if(resp) this._comnUtil.openCallLogPopup(mobile,this.selectedPatientDetails,'Patient');
        else { this._alerSer.error(MsgConfig.IVR_Call_Error); this._commonServ._isCallOngoing$.next(null); }
      } else if(callRequest?.ivrVendor === 2) {
        this._commonServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
        this._comnUtil.openCallLogPopup(mobile,this.selectedPatientDetails,'Patient');
      }
    }    
  }        
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
